import { useEffect, useState } from "react";
import { Button, Select } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { IconUser, IconBriefcase } from "@tabler/icons-react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../helpers/useFetch";

export default function AddStaffModal({ context, id }) {
  const navigate = useNavigate();

  const [positions, setPositions] = useState([]);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebouncedValue(search, 300);
  const [searching, setSearching] = useState(false);

  const [userId, setUserId] = useState(null);
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(false);

  // číselník pozic
  useEffect(() => {
    useFetch(`staff/positions`).then((res) => {
      setPositions((res.data ?? []).map((p) => ({ value: String(p.value), label: p.label })));
    });
  }, []);

  // backend fulltext hledání uživatelů
  useEffect(() => {
    setSearching(true);
    useFetch(`staff/users/search?q=${encodeURIComponent(debouncedSearch)}`)
      .then((res) => {
        setUsers(
          (res.data ?? []).map((u) => ({
            value: String(u.id),
            label: `${u.firstName} ${u.lastName}${u.email ? ` (${u.email})` : ""}`,
          }))
        );
      })
      .finally(() => setSearching(false));
  }, [debouncedSearch]);

  const submit = () => {
    if (!userId || !position) return;
    setLoading(true);
    useFetch(`staff`, "POST", { user_id: Number(userId), position: Number(position) })
      .then((res) => {
        if (res.status === "ok") {
          toast.success("Uživatel byl přidán do personálu.");
          context.closeModal(id);
          navigate(0);
        } else {
          toast.error(res.message ?? "Uživatele se nepodařilo přidat.");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Uživatele se nepodařilo přidat.");
        setLoading(false);
      });
  };

  return (
    <>
      <Select
        label="Uživatel"
        placeholder="Hledej podle emailu..."
        mb="sm"
        leftSection={<IconUser size={16} stroke={1.5} />}
        searchable
        clearable
        disabled={loading}
        value={userId}
        onChange={setUserId}
        searchValue={search}
        onSearchChange={setSearch}
        data={users}
        filter={({ options }) => options}
        nothingFoundMessage={searching ? "Hledám..." : "Nikdo nenalezen"}
      />
      <Select
        label="Funkce"
        placeholder="Vyber pozici..."
        mb="md"
        leftSection={<IconBriefcase size={16} stroke={1.5} />}
        searchable
        disabled={loading}
        value={position}
        onChange={setPosition}
        data={positions}
      />
      <Button fullWidth mt="sm" loading={loading} disabled={!userId || !position} onClick={submit}>
        Přidat do personálu
      </Button>
    </>
  );
}
